module.exports = __webpack_public_path__ + "static/media/logoBlueCross.8e42ea6d.png";